var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiltisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 130,
    viewBox: "0 0 145 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 11C94.8234 11 119 35.1766 119 65C119 94.8234 94.8234 119 65 119C35.1766 119 11 94.8234 11 65C11 35.1766 35.1766 11 65 11Z",
    stroke: "#CA005D",
    strokeWidth: 22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.308 120.625C131.634 120.625 144.058 108.201 144.058 92.8749C144.058 77.5491 131.634 65.1251 116.308 65.1251C100.983 65.1251 88.5586 77.5491 88.5586 92.8749C88.5586 108.201 100.983 120.625 116.308 120.625Z",
    fill: "#00CAA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.06 96.4576L106.058 89.7925L102.559 93.1251L113.06 103.125L130.559 86.46L127.061 83.1251L113.06 96.4576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiltisLogo);
export default __webpack_public_path__ + "static/media/miltis-logo.0115639d61d14c8320c101447c81dd23.svg";
export { ForwardRef as ReactComponent };